import alfalfa from "./alfalfa.png";
import cebada from "./cebada.png";
import centeno from "./centeno.png";
import colza from "./colza.png";
import girasol from "./girasol.png";
import maiz from "./maiz.png";
import nabo from "./nabo.png";
import soja from "./soja.png";
import sorgo from "./sorgo.png";
import trigo from "./trigo.png";

const icons = [
  { name: "Alfalfa", icon: alfalfa },
  { name: "Cebada", icon: cebada },
  { name: "Centeno", icon: centeno },
  { name: "Colza", icon: colza },
  { name: "Girasol", icon: girasol },
  { name: "Maiz", icon: maiz },
  { name: "Nabo", icon: nabo },
  { name: "Soja", icon: soja },
  { name: "Sorgo", icon: sorgo },
  { name: "Trigo", icon: trigo },
];

export default icons;
